import { simpleSet } from '@r/reducers/utils';

const setCalculationModeLegsValue = simpleSet as
  redux.reducers.calculationMode.settings.materials.legs.value;

export const value = setCalculationModeLegsValue(
  'SET_CALCULATION_MODE_LEGS_VALUE',
  { value: '', label: '' }
);
